import Field, { FieldProps as BaseFieldProps } from './field.component';
import { useField } from 'formik';

interface Props {
  name: string;
}

export type FieldProps = Props & BaseFieldProps;

const FormikField: React.FC<FieldProps> = ({ name, ...props }) => {
  const [field, meta] = useField({ name: name });
  const handleChange = (e: any) => {
    field.onChange(e);
    if (props.onChange) {
      props.onChange(e);
    }
  };
  return (
    <Field
      error={Boolean(meta.touched && meta.error)}
      helperText={meta.touched && meta.error ? meta.error : undefined}
      {...field}
      {...props}
      onChange={handleChange}
    />
  );
};

export default FormikField;
